import { Edit3 } from 'lucide-react';
import { DashboardTableRowActionItem, DashboardTableRowActions } from '@shigo-ui/dashboard-ui';

import { dashboardT } from '../../../../lib/messages';

export function SupplyTableRowActions({ onEdit }: { onEdit: () => void }) {
  return (
    <DashboardTableRowActions label={dashboardT('supply.actions')}>
      <DashboardTableRowActionItem onSelect={onEdit}>
        <Edit3 className="h-4 w-4" />
        {dashboardT('supply.edit')}
      </DashboardTableRowActionItem>
    </DashboardTableRowActions>
  );
}
